<template>
  <div>
    <div class="card shadow-sm">
      <div class="card-body">
        <div class="row mt-2">
          <div class="col-12">
            <button id="downloadSummaryOnBoardCrewChart" class="cursor-pointer float-right ml-2 e-btn e-btn-blue-gray force-white-all" @click="getGraphImage">
              <font-awesome-icon class="mr-1" icon="download" />
              Download Graph
            </button>
          </div>
        </div>
        <div class="pie-chart-container" id="bar-chart-container">
          <div class="text-center">
            <h4 class="font-weight-bold text-uppercase">Vessel Manning Summary</h4>
          </div>
          <div>

          </div>
          <div>

          </div>
          <div ref="bar-chart-container">
            <apexchart ref="chart" type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
          </div>
        </div>
      </div>
    </div>

    <!--MODAL-->
    <div class="modal fade" id="perVesselManningCompanyModal" tabindex="-1" aria-labelledby="perVesselManningCompanyModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title d-flex align-items-center justify-content-between" id="perVesselManningCompanyModalLabel">
              <span class="h5">{{ list?.headerName }}</span>
              <select class="form-control" style="width: auto; margin-left: 1rem;" v-if="list?.isAll" v-model="filterVessel">
                <option value="ALL">--ALL---</option>
                <option v-for="(vt, index) in list?.vesselTypes" :key="index" :style="{'background-color': vt?.bgColor}" :value="vt?.type">{{vt?.type}}</option>
              </select>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive table-scroll">
                  <table class="table table-bordered" style="">
                    <thead>
                      <tr>
                        <th class="font-weight-bold text-uppercase text-center align-middle">#</th>
                        <th class="font-weight-bold text-uppercase text-center align-middle">Vessels</th>
                        <th class="font-weight-bold text-uppercase text-center align-middle">Vessel Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(vessel, index) in list.perVesselManningList" :key="index">
                        <template v-if="filterVessel === 'ALL'">
                          <td class="align-middle text-center font-weight-bold">{{index + 1}}</td>
                          <td class="align-middle text-center text-uppercase">{{vessel?.name}}</td>
                          <td class="align-middle text-center text-uppercase">
                            <div class="p-1 font-weight-bolder" :style="{'background-color': vessel?.bgColor, 'color': '#fff'}">{{vessel?.vesselType}}</div>
                          </td>
                        </template>
                        <template v-else-if="vessel?.vesselType === filterVessel">
                          <td class="align-middle text-center font-weight-bold">{{ filteredIndex(index) }}</td>
                          <td class="align-middle text-center text-uppercase">{{vessel?.name}}</td>
                          <td class="align-middle text-center text-uppercase">
                            <div class="p-1 font-weight-bolder" :style="{'background-color': vessel?.bgColor, 'color': '#fff'}">{{vessel?.vesselType}}</div>
                          </td>
                        </template>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {VesselService} from "@/services/VesselService";
import { toBlob } from 'dom-to-image-more';
import { mapGetters, mapActions } from 'vuex'
import AppLoading from "@/components/elements/AppLoading.vue";
export default {
  name: "SummaryPerVesselManningGraphContainer",
  components: {AppLoading},
  data() {
    return {
      loadingModal: false,
      showModal: false,
      list:{
        perVesselManningList: [],
        headerName: null,
        isAll: false,
        vesselTypes: [],
      },
      filterVessel: 'ALL',
    }
  },
  beforeMount(){
    this.getAllVesselManningCompany()
  },
  methods:{
    ...mapActions([
      'getAllVesselManningCompany',
    ]),
    async getGraphImage() {
      swal.fire({
        'title': `Exporting Summary Per Vessel Manning Company`,
        'text': "Please wait...",
        'imageUrl': "https://img.icons8.com/color/400/pie-chart--v1.png",
        'imageWidth': 100,
        'imageHeight': 100,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()

      const blob = await toBlob(this.$refs["bar-chart-container"], {
        pixelRatio: 2,
        backgroundColor: 'white'
      });

      const formData = new FormData();
      formData.append("chart_image", blob, "chart.png");
      formData.append("report_type", 'Vessel Manning Summary by Vessel and Manning Company');

      const printResponse = await VesselService.printSummaryOfManagingVesselGraph(formData);
      swal.close()
      let url = window.URL.createObjectURL(new Blob([printResponse.data],{type:'application/pdf'}))
      let filename=`summary_per_vessel_manning_company_${Date.now()}.pdf`;
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        this.setPieContainerHeight()
      }, 100);
    },
    handleDataPointSelection(event, chartContext, config){
      this.filterVessel = 'ALL'
      const seriesIndex = config?.seriesIndex
      const dataPointIndex = config?.dataPointIndex
      const barColor = chartContext.w.globals.colors[seriesIndex]
      const manningCompany = this.categories?.[dataPointIndex]
      const vesselType = this.series?.[seriesIndex]?.name

      const vesselData = this.vesselManningCompanyList
        .find(m =>
          m.alias?.toUpperCase() ===
          manningCompany?.toUpperCase()
        )
        ?.vessel_types
        ?.find(vt => {
            return vt.code?.toUpperCase() === vesselType?.toUpperCase() || vt.name?.toUpperCase() === vesselType?.toUpperCase()
          }
        )

      const vessels = vesselData?.vessels.map(v => ({
        ...v,
        vesselType: vesselType,
        bgColor: barColor,
      })) || []

      this.list.perVesselManningList = vessels
      this.list.headerName = manningCompany
      this.list.isAll = false
      this.list.vesselTypes = []
      $('#perVesselManningCompanyModal').modal('show')
    },
    setVesselManning(manningCompany){
      this.filterVessel = 'ALL'
      const vesselData = this.vesselManningCompanyList.find(m => m?.alias?.toUpperCase() === manningCompany.toUpperCase())?.vessel_types || []
      // const vesselData = this.vesselManningCompanyList.find(m => m?.alias?.toUpperCase() === manningCompany.toUpperCase())?.vessel_types?.filter(vt => ['BULK', 'PCC'].includes(vt?.code?.toUpperCase())) || []

      const barColorFinder = (v) => {
        const seriesIndex = this.series.findIndex(
          s => s.name.toUpperCase() === v?.code.toUpperCase() || s.name.toUpperCase() === v?.name.toUpperCase()
        )

        return this.$refs.chart?.chart?.w?.globals?.colors?.[seriesIndex]
      }

      const vesselTypes = vesselData.map(vt => {
        const type = vt?.code?.trim() ? vt.code.toUpperCase() : vt.name.toUpperCase()
        const code = vt.code.toUpperCase()
        const name = vt.name.toUpperCase()
        const bgColor = barColorFinder({code, name})

        return { type, bgColor }
      })

      const vessels = vesselData.flatMap(v =>
        (v?.vessels || []).map(vessel => {

          const barColor = barColorFinder(v)

          v?.code && v?.code.trim() !== '' ? v?.code : v?.name
          return {
            ...vessel,
            vesselType: v?.code && v?.code.trim() !== '' ? v?.code.toUpperCase() : v?.name.toUpperCase(),
            bgColor: barColor,
          }
        })
      )

      this.list.perVesselManningList = vessels
      this.list.headerName = manningCompany
      this.list.isAll = true
      this.list.vesselTypes = vesselTypes
      $('#perVesselManningCompanyModal').modal('show')
    },
    addYAxisClickHandler() {
      setTimeout(() => {
        const labels = document.querySelectorAll('.apexcharts-yaxis-label');
        labels.forEach((label, index) => {
          label.style.cursor = 'pointer';
          label.addEventListener('click', () => {
            const manningCompany = this.chartOptions.xaxis.categories[index];
            this.selectedShipbuilder = manningCompany;
            this.bracketClicked = null;
            this.setVesselManning(manningCompany)
          });
        });
      }, 300);
    },
    filteredIndex(currentIndex) {
      // Count how many filtered vessels came before this index
      let count = 0
      for (let i = 0; i <= currentIndex; i++) {
        if (
          this.filterVessel === 'ALL' ||
          this.list.perVesselManningList[i]?.vesselType === this.filterVessel
        ) {
          count++
        }
      }
      return count
    }
  },
  computed:{
    ...mapGetters([
      'vesselManningCompanyList',
    ]),
    categories() {
      return this.vesselManningCompanyList.map(({ alias }) => alias.toUpperCase());
    },
    vesselTypes() {
      return [...new Set(
        this.vesselManningCompanyList.flatMap(manning =>
          manning?.vessel_types.map(vt => vt.code && vt.code.trim() !== '' ? vt.code : vt.name)
            // .filter(vtName => ['BULK', 'PCC'].includes(vtName))
        )
      )]
    },
    series(){
      return this.vesselTypes.map(vtName => ({
        name: vtName.toUpperCase(),
        data: this.vesselManningCompanyList.map(manning => {
          const vt = manning?.vessel_types.find(v => v.code === vtName || v.name === vtName)
          return vt ? vt.vessels.length : 0
        })
      }))
    },
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          height: 500,
          stacked: true,
          horizontal: true,
          toolbar: { show: false },
          zoom: {
            enabled: false
          },
          events:{
            dataPointSelection: (event, chartContext, config) => {
              this.handleDataPointSelection(event, chartContext, config)
            },
            mounted: () => {
              this.$nextTick(() => {
                this.addYAxisClickHandler()
              })
            },
            updated: () => {
              this.$nextTick(() => {
                this.addYAxisClickHandler();
              });
            },
          },
        },
        dataLabels:{
          enabled: true,
          style:{
            colors:['#fff'],
            fontSize: "12px",
          },
          background: {
            padding: 10,
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 0,
            barHeight: '90%',
            columnWidth: '100%',
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 10,
                style: {
                  fontSize: '14px',
                  fontWeight: 900,
                }
              }
            }
          }
        },
        stroke: {
          width: 1,
          colors: ['#fff'],
          show: true,
        },
        xaxis: {
          categories: this.categories,
          labels: {
            formatter: function (val) {
              return val;
            },
            style:{
              fontSize: '11px',
            },
          },
          title: {
            text: 'NUMBER OF VESSEL ASSIGNED',
          },
        },
        yaxis: {
          title: {
            text: 'BAR GRAPH PER VESSEL MANNING COMPANY',
            // offsetX: 10,
            // offsetY: 0,
          },
          labels:{
            align: 'right',
            trim: false,
            offsetX: 10,
            minWidth: 0,
            maxWidth: 400,
            style: { fontSize: "11px" },
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            }
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          offsetX: 100,
        },
        grid:{
          padding:{
            left: 10,
            right: 10,
          }
        },
      };
    }
  }
}
</script>
<style scoped>
.modal-custom-width{
  max-width: 90%;
}
.table-scroll {
  max-height: 400px;
  overflow-y: auto;
}
</style>
